export default __webpack_public_path__ + "static/apparel-mf-search-for-buyers-1-a71cd139dbe2a430f63c81d3491a9f64.png";